export const experimentConfig = {
  codecanyonNarrowItemCard: '2oVLIOcfTLyg4g0mwqff0w',
  categoryPage: '44zEXpiVShq0pa6a_HMiVw'
}

export default experimentConfig
